"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIAssistSignalHelper = void 0;
const assistant_component_types_1 = require("../types/assistant.component.types");
const timing_helper_1 = require("./timing.helper");
/**
 * Static helper class for managing AI Assistant signals
 */
class AIAssistSignalHelper {
    /**
     * Send add entry signal
     */
    static addEntry(signal, entry) {
        const assistSignal = {
            command: assistant_component_types_1.AssistantSignalCommand.ADD_ENTRY,
            entry: entry
        };
        signal.setValue(assistSignal);
    }
    /**
     * Send minimize signal
     */
    static minimize(signal) {
        const assistSignal = {
            command: assistant_component_types_1.AssistantSignalCommand.MINIMIZE
        };
        signal.setValue(assistSignal);
    }
    /**
     * Send maximize signal
     */
    static maximize(signal) {
        const assistSignal = {
            command: assistant_component_types_1.AssistantSignalCommand.MAXIMIZE
        };
        signal.setValue(assistSignal);
    }
    /**
     * Send clear entries signal
     */
    static clearEntries(signal) {
        const assistSignal = {
            command: assistant_component_types_1.AssistantSignalCommand.CLEAR_ENTRIES
        };
        signal.setValue(assistSignal);
    }
    /**
     * Send select entry signal
     */
    static selectEntry(signal, entryId) {
        const assistSignal = {
            command: assistant_component_types_1.AssistantSignalCommand.SELECT_ENTRY,
            entryId: entryId
        };
        signal.setValue(assistSignal);
    }
    /**
     * Send update context signal
     */
    static updateContext(signal, context) {
        const assistSignal = {
            command: assistant_component_types_1.AssistantSignalCommand.UPDATE_CONTEXT,
            context: context
        };
        signal.setValue(assistSignal);
    }
    /**
     * Send clear timeout signal
     */
    static clearTimeout(signal) {
        const assistSignal = {
            command: assistant_component_types_1.AssistantSignalCommand.CLEAR_TIMEOUT
        };
        signal.setValue(assistSignal);
    }
    /**
     * Process assistant signal and update component state
     */
    static processSignal(signal, context) {
        if (!signal) {
            return context;
        }
        const updatedContext = { ...context };
        switch (signal.command) {
            case assistant_component_types_1.AssistantSignalCommand.ADD_ENTRY:
                if (signal.entry) {
                    updatedContext.entries = [...context.entries, signal.entry];
                    // Scroll to bottom after adding new entry
                    setTimeout(() => context.ensureScrollToBottom(), 50);
                }
                break;
            case assistant_component_types_1.AssistantSignalCommand.MINIMIZE:
                updatedContext.minimized = true;
                break;
            case assistant_component_types_1.AssistantSignalCommand.MAXIMIZE:
                updatedContext.minimized = false;
                break;
            case assistant_component_types_1.AssistantSignalCommand.CLEAR_ENTRIES:
                updatedContext.entries = [];
                updatedContext.activeEntry = null;
                updatedContext.proposedKnowledgeIds = []; // Clear proposed knowledge IDs when clearing entries
                break;
            case assistant_component_types_1.AssistantSignalCommand.SELECT_ENTRY:
                if (signal.entryId !== undefined) {
                    const entryIndex = typeof signal.entryId === 'number' ? signal.entryId : parseInt(signal.entryId.toString());
                    if (entryIndex >= 0 && entryIndex < updatedContext.entries.length) {
                        updatedContext.activeEntry = updatedContext.entries[entryIndex];
                    }
                }
                break;
            case assistant_component_types_1.AssistantSignalCommand.UPDATE_CONTEXT:
                if (signal.context) {
                    updatedContext.currentContext = signal.context;
                }
                break;
            case assistant_component_types_1.AssistantSignalCommand.CLEAR_TIMEOUT:
                if (updatedContext.reactionTimeout) {
                    timing_helper_1.AIAssistTimingHelper.clearTimeout(updatedContext.reactionTimeout);
                    updatedContext.reactionTimeout = null;
                }
                break;
        }
        return updatedContext;
    }
}
exports.AIAssistSignalHelper = AIAssistSignalHelper;
